/**
 * Notification Store
 * 
 * Manages temporary notifications shown to the user.
 * Used for non-blocking warnings and info messages.
 */

import { create } from 'zustand';

export type NotificationType = 'warning' | 'info' | 'error';

export interface Notification {
  id: string;
  message: string;
  type: NotificationType;
  duration?: number; // Auto-dismiss after ms (default: 3000)
}

interface NotificationState {
  notifications: Notification[];
  showNotification: (message: string, type?: NotificationType, duration?: number) => void;
  dismissNotification: (id: string) => void;
}

export const useNotificationStore = create<NotificationState>((set, get) => ({
  notifications: [],

  showNotification: (message, type = 'info', duration = 3000) => {
    const id = `notification-${Date.now()}-${Math.random()}`;
    const notification: Notification = { id, message, type, duration };

    set((state) => ({
      notifications: [...state.notifications, notification],
    }));

    // Auto-dismiss after duration
    if (duration > 0) {
      setTimeout(() => {
        get().dismissNotification(id);
      }, duration);
    }
  },

  dismissNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },
}));
